import { render, staticRenderFns } from "./page6.vue?vue&type=template&id=d6971642&scoped=true&"
import script from "./page6.vue?vue&type=script&lang=js&"
export * from "./page6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6971642",
  null
  
)

export default component.exports